export default "__VITE_ASSET__JQjVuJPA__"